import {set} from '@/utils/vuex';

export default {
    onNotification: set('notification')
}
